<template>
	<div class="navigation-drawer__user-content">
		<v-tooltip
			lazy
			right
			color="grey darken-3"
			open-delay="400"
			:disabled="mobile">
			<v-btn
				icon
				slot="activator"
				@click="handleNotificationClick">
				<v-badge
					overlap
					color="red darken-4">
					<span class="white--text" slot="badge" v-if="unreadNotificationCount">
						{{ unreadNotificationCount }}
					</span>
					<v-icon color="grey darken-2">notifications</v-icon>
				</v-badge>
			</v-btn>
			<span class="grey--text text--lighten-3">Notifications</span>
		</v-tooltip>

		<v-tooltip
			lazy
			right
			color="grey darken-3"
			open-delay="400"
			:disable="mobile">
			<v-btn
				icon
				@click="openHelpMenu"
				slot="activator">
				<v-icon color="grey darken-2">help</v-icon>
			</v-btn>
			<span class="grey--text text--lighten-3">Help</span>
		</v-tooltip>

		<v-tooltip
			lazy
			right
			color="grey darken-3"
			open-delay="400"
			:disabled="mobile">
			<v-btn
				icon
				slot="activator"
				v-on:click="handleLogoutClick">
				<v-icon color="grey darken-2" class="rotate-180">exit_to_app</v-icon>
			</v-btn>
			<span class="grey--text text--lighten-3">Log Out</span>
		</v-tooltip>

		<v-tooltip
			lazy
			right
			color="grey darken-3"
			open-delay="400"
			:disabled="mobile">
			<v-btn
				icon
				slot="activator"
				@click="handleAvatarClick">
				<v-avatar size="32px">
					<img :src="extractUserAvatarUrl({ user: user })" alt="avatar">
				</v-avatar>
			</v-btn>
			<span class="grey--text text--lighten-3">My Account</span>
		</v-tooltip>
	</div>
</template>


<script>
	import { mapActions, mapGetters, mapState } from 'vuex'
	import { VUEX_UI_SHOW_LEFT_DRAWER, VUEX_UI_HIDE_NAVIGATION_DRAWER } from '@/store/constants/ui'
	import { VUEX_AUTH_LOGOUT } from '@/store/constants/auth'
	import extractUserAvatarUrl from '@/helpers/extractUserAvatarUrl'
	import HelpDeskObserver from '@/mixins/helpDeskObserver'

	export default {
		name: 'navigation-drawer--user-content',

		data() {
			return {}
		},

		computed: {
			...mapGetters({
				extractUserAvatar: 'extractUserAvatar'
			}),

			...mapState({
				user: state => state.auth.currentUser,
				mobile: state => state.mobile.mobile,
				unreadNotificationCount: state => state.notifications.unseenCount,
			})
		},

		mixins: [
			HelpDeskObserver
		],

		methods: {
			extractUserAvatarUrl, 
			
			...mapActions({
				showLeftDrawer: VUEX_UI_SHOW_LEFT_DRAWER,
				closeDrawer: VUEX_UI_HIDE_NAVIGATION_DRAWER
			}),

			handleNotificationClick() {
				this.showLeftDrawer()
			},

			handleLogoutClick() {
				this.$store.dispatch(VUEX_AUTH_LOGOUT).then(() => {
					this.$router.replace({ name: 'login' })
				})
			},

			handleAvatarClick() {
				if (this.mobile === true) return
				this.$router.push({ name: 'admin-user-edit', params: { userId: this.user.id } })
			},

			openHelpMenu() {
				if (this.mobile) {
					this.closeDrawer()
				}
				HelpDeskObserver.startObserver()
				document.getElementById('jsd-widget').contentWindow.document.getElementById('help-button').click()
				document.getElementById('jsd-widget').style.display = 'block'
			}

		},

	}
</script>